import { useAuth } from "../hooks/useAuth";
import styles from "./AuthGuard.module.css";

interface AuthGuardProps {
  children: React.ReactNode;
  loginUrl?: string;
}

export function AuthGuard({ children, loginUrl }: AuthGuardProps) {
  const auth = useAuth();

  if (auth.status === "loading") {
    return (
      <div className={styles.container}>
        <div className={styles.spinner} />
        <p className={styles.text}>Checking authentication…</p>
      </div>
    );
  }

  if (auth.status === "unauthenticated") {
    const target = loginUrl || import.meta.env.VITE_LOGIN_URL || "/";
    return (
      <div className={styles.container}>
        <div className={styles.icon}>🔒</div>
        <h1 className={styles.title}>Sign in required</h1>
        <p className={styles.text}>You need to be signed in to access the admin panel.</p>
        <a href={target} className={styles.link}>
          Go to login →
        </a>
      </div>
    );
  }

  if (auth.status === "forbidden") {
    return (
      <div className={styles.container}>
        <div className={styles.icon}>⛔</div>
        <h1 className={styles.title}>Access denied</h1>
        <p className={styles.text}>
          Your account does not have admin privileges. Contact a super admin if you believe this is
          an error.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
